module.exports = "/_next/static/images/avatar-frame-tier-2-9601d388a29ae72a5329a604f99f1ca4.png";